import { render, staticRenderFns } from "./FrmServiceType.vue?vue&type=template&id=bb2bc90e&scoped=true"
import script from "./FrmServiceType.vue?vue&type=script&lang=js"
export * from "./FrmServiceType.vue?vue&type=script&lang=js"
import style0 from "./FrmServiceType.vue?vue&type=style&index=0&id=bb2bc90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2bc90e",
  null
  
)

export default component.exports